module.exports = __webpack_public_path__ + "img/visits-pa.2f5d0b8c.svg";